export default "__VITE_ASSET__ae5ecd70__"